import React from 'react';
import PropTypes from 'prop-types';

export default class WarningBox extends React.Component {
  static propTypes = {
    cancelFunction: PropTypes.func,
    cancelText: PropTypes.string,
    keepAliveFunction: PropTypes.func,
    keepAliveText: PropTypes.string,
    text: PropTypes.string.isRequired,
    time: PropTypes.number,
  };

  static defaultProps = {
    cancelFunction: null,
    cancelText: '',
    keepAliveFunction: null,
    keepAliveText: '',
    time: null,
  };

  state = {
    minutes: 0,
    seconds: 0,
  };

  componentWillMount = () => {
    const { time } = this.props;
    if (time) {
      this.updateClock(this.countdown);
      this.clockInterval = setInterval(() => {
        this.updateClock(this.countdown);
      }, 1000);
    }
  };

  componentWillUnmount = () => {
    if (this.clockInterval) clearInterval(this.clockInterval);
  };

  getTimeRemaining = totalTime => {
    let seconds = Math.floor((totalTime / 1000) % 60);
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    const minutes = Math.floor((totalTime / 1000 / 60) % 60);
    return {
      minutes,
      seconds,
    };
  };

  updateClock = totalTime => {
    const { cancelFunction } = this.props;

    if (totalTime <= 0) {
      if (this.clockInterval) clearInterval(this.clockInterval);
      if (cancelFunction) {
        cancelFunction();
      }
      return;
    }
    this.setState({
      minutes: this.getTimeRemaining(totalTime).minutes,
      seconds: this.getTimeRemaining(totalTime).seconds,
    });
    this.countdown = this.countdown - 1000;
  };

  clockInterval = null;
  countdown = this.props.time;

  renderKeepAliveButton = () => {
    const { keepAliveFunction, keepAliveText } = this.props;
    return (
      <button type="button" className="btn btn-warning" onClick={keepAliveFunction}>
        {keepAliveText}
      </button>
    );
  };

  renderCancelButton = () => {
    const { cancelFunction, cancelText } = this.props;
    return (
      <button type="button" className="btn btn-secondary" onClick={cancelFunction}>
        {cancelText}
      </button>
    );
  };

  renderCountdown = () => {
    const { minutes, seconds } = this.state;
    return (
      <p className="countdown">
        <strong>Time Left: </strong>
        <span className="minutes">{minutes}</span>:
        <span className="seconds">{seconds}</span>
      </p>
    );
  };

  render() {
    const { text, time, keepAliveFunction, cancelFunction } = this.props;
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="alert alert-warning">
            <p className="message">
              <i className="fa fa-exclamation-triangle" aria-hidden="true" /> {text}
            </p>
            {time ? this.renderCountdown() : null}
            <div className="text-xs-center">
              {keepAliveFunction ? this.renderKeepAliveButton() : null}
              &nbsp;
              {cancelFunction ? this.renderCancelButton() : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
